/**
 * Aberto ou fechado, o acordeão "Texto explicativo: As 12 Estações da Coloração Pessoal" VIVE COM A
 * PÁGINA, e não com a aba (linha 205 do inventário).
 *
 * No legado o acordeão é um `div` que nunca sai da página, e só uma coisa o fecha sem a pessoa
 * clicar: a primeira linha do `carregarQuestionarios`, que tira o `aberto` de TODO acordeão
 * (`admin.html:5021`). Ela roda ao abrir a cliente (`5979`), ao entrar em Questionário Geral,
 * Personalidade, Radar e Avaliativo (`5066-5069`, pelo `CARREGADOR_ABA_CLIENTE`) e depois de salvar
 * o Questionário Geral e a Personalidade (`4884`, `4918`). Ir a Milhões ou à Lista de Desejos e
 * voltar deixa o acordeão como estava. A moldura nova desmonta a aba ao trocar, então guardar o
 * aberto no componente o fecharia em toda troca: foi o achado da verificação independente da A7.
 *
 * O QUE AQUI REPRODUZ CADA GATILHO:
 *   - abrir a cliente: o aberto vale só para o objeto `ficha` em que foi aberto, e a moldura cria um
 *     objeto novo a cada abertura (`ficha-cliente/index.tsx:137-147`, remontada pela chave de
 *     cliente e lead em `204-209`). Abriu de novo, mesmo a mesma cliente, nasce fechado;
 *   - entrar no Avaliativo: a aba chama `fecharAcordeoes` ao ler, como o `carregarQuestionarios`;
 *   - entrar em Questionário Geral, Personalidade e Radar, e salvar os dois questionários: são
 *     arquivos de outras frentes, e a chamada a `fecharAcordeoes` neles foi pedida ao principal.
 *     Até lá, voltar de uma dessas abas encontra o acordeão como a pessoa deixou (divergência
 *     declarada em `progresso/PARIDADE-A7.md`, linha 205).
 */

// O gancho do React que assina uma fonte externa ao componente.
import { useSyncExternalStore } from 'react';
// O contrato da ficha: o objeto aberto é a chave da abertura.
import type { FichaAberta } from '../../comum-ficha/tipos.js';

// A ficha em que o acordeão foi aberto; `null` é fechado. Um objeto só, e não um booleano, para
// "abriu a cliente de novo" valer como fechado sem ninguém precisar avisar.
let abertoNaFicha: FichaAberta | null = null;
// Quem está desenhando o acordeão agora.
const ouvintes = new Set<() => void>();

// Troca o estado e avisa quem desenha.
function definir(ficha: FichaAberta | null): void {
  if (ficha === abertoNaFicha) return;
  abertoNaFicha = ficha;
  for (const aoMudar of ouvintes) aoMudar();
}

// A inscrição de quem desenha, no formato do `useSyncExternalStore`.
function assinar(aoMudar: () => void): () => void {
  ouvintes.add(aoMudar);
  return () => {
    ouvintes.delete(aoMudar);
  };
}

// O estado atual, lido pelo React a cada desenho.
function ler(): FichaAberta | null {
  return abertoNaFicha;
}

/**
 * Fecha todo acordeão, como `document.querySelectorAll('.acordeon').forEach((ac) =>
 * ac.classList.remove('aberto'))`, a primeira linha do `carregarQuestionarios` (`admin.html:5021`).
 * Quem roda o equivalente ao `carregarQuestionarios` chama isto antes de ler.
 */
export function fecharAcordeoes(): void {
  definir(null);
}

/** Aberto ou fechado nesta ficha, e a função que o clique no cabeçalho chama. */
export function useAcordeaoExplicativo(ficha: FichaAberta): readonly [boolean, (aberto: boolean) => void] {
  // O segundo `ler` é o valor para o desenho no servidor, que este app não faz, mas o gancho pede.
  const fichaAberta = useSyncExternalStore(assinar, ler, ler);
  // Aberto só se foi aberto NESTA abertura da ficha.
  const aberto = fichaAberta === ficha;
  return [aberto, (abrir: boolean) => definir(abrir ? ficha : null)] as const;
}
